import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import "nes.css.14x/css/nes.min.css";
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
